module.exports = __webpack_public_path__ + "static/media/1014736.829dc6fb.jpg";